import React, { Component } from 'react';
import { Container, Row, Col } from 'reactstrap';
import { RichText } from '@payloadcms/richtext-lexical/react';

class Page extends Component {
    constructor(props) {
        super(props);

        this.state = {
            page: null,
            loading: true,
            error: null,
        };
    }

    componentDidMount() {
        this.loadPage();
    }

    componentDidUpdate(prevProps) {
        if (prevProps.slug !== this.props.slug) {
            this.loadPage();
        }
    }

    loadPage = () => {
        const { slug } = this.props;

        if (!slug) {
            this.setState({
                page: null,
                loading: false,
                error: 'No page slug provided.',
            });
            return;
        }

        this.setState({
            page: null,
            loading: true,
            error: null,
        });

        fetch(
            `${process.env.REACT_APP_API_URL}/api/pages?where[slug][equals]=${encodeURIComponent(
                slug
            )}&depth=1&limit=1`
        )
            .then((res) => {
                if (!res.ok) throw new Error(`HTTP error ${res.status}`);
                return res.json();
            })
            .then((data) => {
                const page = data?.docs?.[0] || null;

                if (!page) {
                    this.setState({
                        page: null,
                        loading: false,
                        error: `Page "${slug}" not found.`,
                    });
                    return;
                }

                this.setState({
                    page,
                    loading: false,
                    error: null,
                });
            })
            .catch((error) => {
                console.error('Page fetch error:', error);
                this.setState({
                    page: null,
                    loading: false,
                    error: error.message || 'Failed to load page.',
                });
            });
    };

    getMediaUrl = (mediaObj) => {
        if (!mediaObj) return '';

        if (mediaObj.filename) {
            return `${process.env.REACT_APP_API_URL}/api/media/file/${mediaObj.filename}`;
        }

        if (mediaObj.url) {
            return mediaObj.url;
        }

        return '';
    };

    hasRichTextContent = (content) => {
        return Boolean(
            content &&
            content.root &&
            Array.isArray(content.root.children) &&
            content.root.children.length > 0
        );
    };

    render() {
        const { page, loading, error } = this.state;

        if (loading) {
            return (
                <Container className="my-5">
                    <p className="text-center">Loading page...</p>
                </Container>
            );
        }

        if (error) {
            return (
                <Container className="my-5">
                    <p className="text-center text-danger">Error: {error}</p>
                </Container>
            );
        }

        if (!page) {
            return (
                <Container className="my-5">
                    <p className="text-center">No page found.</p>
                </Container>
            );
        }

        const images = page.images || [];
        const hasContent = this.hasRichTextContent(page.content);

        return (
            <Container className="my-5">
                <Row className="mb-4">
                    <Col xs={12}>
                        <h1>{page.title}</h1>
                    </Col>
                </Row>

                {hasContent && (
                    <Row className="mb-4">
                        <Col xs={12}>
                            <RichText data={page.content} />
                        </Col>
                    </Row>
                )}

                {images.length > 0 && (
                    <Row>
                        {images.map((imgItem, index) => {
                            const imageUrl = this.getMediaUrl(imgItem.image);

                            return (
                                <Col key={index} lg={4} md={6} xs={12} className="mb-4">
                                    {imageUrl ? (
                                        <img
                                            src={imageUrl}
                                            alt={imgItem.caption || page.title}
                                            style={{
                                                width: '100%',
                                                height: 'auto',
                                                objectFit: 'cover',
                                            }}
                                        />
                                    ) : (
                                        <div>No image</div>
                                    )}

                                    {imgItem.caption && (
                                        <p style={{ marginTop: '0.5rem', color: '#666' }}>
                                            {imgItem.caption}
                                        </p>
                                    )}
                                </Col>
                            );
                        })}
                    </Row>
                )}
            </Container>
        );
    }
}

export default Page;